import React, { useState, useEffect } from "react";
import styled from "styled-components";
import PersistentModal from "../../interface/PersistentModal";
import StarRating from "../activeFaults/StarRating";
import ActiveFaultsDetailsTabForm from "../activeFaults/DetailsTabForm";

const CardContainer = styled.div`
  width: 100%;
  height: auto;
  flex-shrink: 0;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.4rem;
  overflow: hidden;
  transition: transform 1.3s ease-in-out, opacity 1.3s ease-in-out;
`;

const Card = styled.div`
  position: relative;
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0.2em;
  border-radius: 10px;
  backdrop-filter: blur(30px);
  background-color: var(--color-grey-0);
  border: 1px solid var(--color-grey-200);
  cursor: pointer;
  box-shadow: var(--shadow-div-md);
  font-size: clamp(0.8rem, 5vw, 1.3rem);
`;

const StatusGroup = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-left: 0.5rem;
  margin-right: 0.5rem;
  flex: 1;
`;

const InfoGroup = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 3;
`;

const Duration = styled.div`
  font-weight: 700;
  font-size: 1.5em;
  letter-spacing: 1.2px;
  color: var(--color-grey-900);
  margin-right: 1em;
`;

const Info = styled.div`
  font-weight: 500;
  font-size: 1.1em;

  color: var(--color-grey-800);
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const Location = styled.div`
  font-size: 0.9em;
  color: var(--color-grey-900);
`;

const LocContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex: 1;
`;

const InfoBox = styled.div`
  width: 33%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0px 10px;
  gap: 4px;

  &:not(:last-child) {
    border-right: 1px solid var(--color-witron-blue);
  }
`;

const InfoHeading = styled.div`
  font-size: 0.6em;
  font-weight: 600;
  color: var(--color-witron-blue);
`;

const InfoValue = styled.div`
  font-size: 0.9em;
  font-weight: 500;
  color: var(--color-grey-800);
  min-height: 1em;
  max-width: 2ch;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

function FaultListItem({ fault }) {
  const [timeDifference, setTimeDifference] = useState(fault.duration);

  useEffect(() => {
    const interval = setInterval(() => {
      setTimeDifference((prev) => prev + 1000);
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  const hours = String(Math.floor(timeDifference / (1000 * 60 * 60))).padStart(
    2,
    "0"
  );
  const minutes = String(
    Math.floor((timeDifference % (1000 * 60 * 60)) / (1000 * 60))
  ).padStart(2, "0");
  const seconds = String(
    Math.floor((timeDifference % (1000 * 60)) / 1000)
  ).padStart(2, "0");

  function mapPriorityToStars(priority) {
    switch (priority) {
      case 1:
        return 4;
      case 2:
        return 3;
      case 3:
        return 2;
      case 4:
        return 1;
      case 5:
      case null:
      default:
        return 0;
    }
  }

  const translatedRating = mapPriorityToStars(fault.priority);

  return (
    <CardContainer>
      <PersistentModal>
        <PersistentModal.Open opens="settings">
          <Card>
            <StatusGroup>
              <Duration>{`${hours}:${minutes}:${seconds}`}</Duration>
              <StarRating defaultRating={translatedRating} />
            </StatusGroup>
            <InfoGroup>
              <Info>{fault.faultInfo}</Info>
              <Location>{fault.locationRaw}</Location>
            </InfoGroup>
            <LocContainer>
              <InfoBox>
                <InfoHeading>GC</InfoHeading>
                <InfoValue>{fault.gc}</InfoValue>
              </InfoBox>
              <InfoBox>
                <InfoHeading>LAC</InfoHeading>
                <InfoValue>{fault.lac}</InfoValue>
              </InfoBox>
              <InfoBox>
                <InfoHeading>POS</InfoHeading>
                <InfoValue>{fault.pos}</InfoValue>
              </InfoBox>
            </LocContainer>
          </Card>
        </PersistentModal.Open>
        <PersistentModal.Window name="settings">
          <ActiveFaultsDetailsTabForm fault={fault} />
        </PersistentModal.Window>
      </PersistentModal>
    </CardContainer>
  );
}

export default FaultListItem;
